<template>
	<div click.stop>
		<div class="modal is-active">
			<div class="modal-background" @click="cancel"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">
						{{ $t('question_modal.title') }}
					</p>
					<button class="delete" aria-label="close" @click="cancel"></button>
				</header>
				<section class="modal-card-body no-scroll">
					<div class="columns is-mobile">
						<div class="field column">
							<label class="label">{{ $t('question_modal.description') }}</label>
							<div class="control">
								<input
									type="text"
									v-model="question.answerDescription"
									class="input"
									:placeholder="$t('question_modal.description_placeholder')"
								/>
							</div>
						</div>
						<div class="field check">
							<label class="label"> {{ $t('question_modal.fixed') }}</label>
							<div class="control">
								<switchButton v-model="isFixed" />
							</div>
						</div>
					</div>
				</section>
				<footer class="modal-card-foot">
					<div class="column">
						<button class="button is-dark" @click="save">
							<span class="icon is-info"><i class="fas fa-save"/></span
							><span>{{ $t('question_modal.save') }}</span>
						</button>
					</div>
				</footer>
			</div>
		</div>
	</div>
</template>
  
<script>
import switchButton from '@/components/switchButton';
export default {
	components: {
		switchButton
	},
	props: {
		editQuestion: Object
	},
	data() {
		return {
			question: {},
			isFixed: false
		};
	},
	methods: {
		save() {
			if (this.isFixed) {
				let date = new Date();
				date.setHours(date.getHours() - date.getTimezoneOffset() / 60);
				this.question.done = date;
			}

			this.$emit('save', this.question);
		},
		cancel() {
			this.$emit('cancel');
		}
	},
	created() {
		this.question = Object.assign({}, this.editQuestion);
		this.isFixed = this.question.done ? true : false;
	}
};
</script>
  
  <style lang="scss" scoped>
  .check {
    margin-top: 0.6rem;
  }
  </style>
  